import { AgpmRepository } from '../../../../store/agpm-state/agpm-state.repository';
import {
  DataTableColumnBadgeProps,
  DataTableColumnDateProps,
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableRowActions,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '../../../../components/data-table-builder/data-table.types';
import { Agpm } from '@/types';

interface getCurrentNoticeDataTableStructureProps {
  store: AgpmRepository;
  createAction?: () => void;
  rowActionsFn?: (...args: any[]) => DataTableRowActions;
}

export const getCurrentNoticeDataTableStructure = ({
  store,
  createAction,
  rowActionsFn,
}: getCurrentNoticeDataTableStructureProps): DynamicDataTable => {
  const yearColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'agpm.table.year',
    accessorKey: 'annee',
    variant: DataTableColumnVariant.TEXT,
  };

  const processStepColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'agpm.table.processStep',
    accessorKey: 'etapeProcess',
    variant: DataTableColumnVariant.TEXT,
    renderAs: (value: string) => {
      if (!value) return { value: 'Non défini', class: 'opacity-70' };
      return { value };
    },
  };

  const refColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'agpm.table.ref',
    accessorKey: 'ref',
    variant: DataTableColumnVariant.TEXT,
  };
  const nomColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'agpm.table.nom',
    accessorKey: 'nom',
    variant: DataTableColumnVariant.TEXT,
    class: 'truncate w-[10vw] min-w-0',
  };

  const acColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'agpm.table.ac',
    accessorKey: 'ac.nom',
    variant: DataTableColumnVariant.TEXT,
  };

  const statusIdColumn: DynamicDataTableColumn<DataTableColumnBadgeProps> = {
    label: 'agpm.table.status',
    accessorKey: 'status',
    variant: DataTableColumnVariant.BADGE,
    renderAs: (value: string) => {
      return {
        value: `agpm.status.${value}`,
      };
    },
    props: {
      getSeverity: (value: string) => {
        if (value === 'BROUILLON') return 'primary';
        if (value === 'EN_TRAITEMENT') return 'contrast';
        if (value === 'VALIDE') return 'success';
        if (value === 'PUBLIE') return 'info';
        return 'danger';
      },
    },
  };
  const createdAtColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'agpm.table.createdAt',
    accessorKey: 'metadata.createdAt',
    variant: DataTableColumnVariant.DATE,
    props: {
      format: 'dd/MM/yyyy HH:mm',
    },
  };

  const updatedAtColumn: DynamicDataTableColumn<DataTableColumnDateProps> = {
    label: 'agpm.table.updatedAt',
    accessorKey: 'metadata.updatedAt',
    variant: DataTableColumnVariant.DATE,
    props: {
      format: 'dd/MM/yyyy HH:mm',
    },
  };

  // const createdByColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
  //   label: 'agpm.table.createdBy',
  //   accessorKey: 'createdBy',
  //   variant: DataTableColumnVariant.TEXT,
  // };

  // const updatedByColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
  //   label: 'agpm.table.updatedBy',
  //   accessorKey: 'updatedBy',
  //   variant: DataTableColumnVariant.TEXT,
  // };

  return {
    singular: 'agpm.singular',
    plural: 'agpm.plural',
    data: [],
    columns: [
      yearColumn,
      refColumn,
      nomColumn,
      acColumn,
      statusIdColumn,
      processStepColumn,
      createdAtColumn /*createdByColumn*/,
      updatedAtColumn /*updatedByColumn*/,
    ],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    target: (row: Agpm) => {
      store.setNested('response', row);
      store.setNested('dto', {
        ref: row.ref,
        nom: row.nom,
        contenu: row.contenu,
        remarque: row.remarque,
        docIds: row.docs.map(doc => doc.id),
        files: [],
      });
    },
    createAction,
    rowActionsFn,
    searchableFields: ['ref', 'nom', 'contenu', 'remarque', 'ac.nom'],
  };
};
